<template>
  <div>
    <v-card class="form">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>نام رشته:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <span>{{ reshte.Text }}</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="comment" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>مکان پیشنهادی برای مصاحبه:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select
            :items="items"
            item-text="text"
            item-value="value"
            v-model="ostan"
          ></v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input label="پيوست مستندات" v-model="image"></v-file-input>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <span
            >در صورتی که قصد الصاق چندین فایل را دارید، می بایست ابتدا آن ها را
            فشرده کرده و سپس فایل فشرده را ارسال نمایید.</span
          >
        </v-col>
      </v-row>
    </v-card>
    <app-actions
      @nextStep="nextStep"
      :showCancel="true"
      :lastStep="true"
      @prevStep="prevStep"
    ></app-actions>
  </div>
</template>

<script>
import Actions from "./Actions";
export default {
  components: {
    appActions: Actions,
  },
  data() {
    return {
      comment: "",
      image: null,
      items: [
        { value: "خراسان رضوی", text: "خراسان رضوی" },
        { value: "خراسان شمالی", text: "خراسان شمالی" },
        { value: "خراسان جنوبی", text: "خراسان جنوبی" },
      ],
      ostan: "",
    };
  },
  props: ["reshte"],
  methods: {
    nextStep() {
      this.$emit("nextStep", {
        comment: this.comment,
        ostan: this.ostan,
        image: this.image,
      });
    },
    prevStep() {
      this.$emit("prevStep");
    },
  },
};
</script>
<style scoped>
ol {
  padding-right: 36px;
}



@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
